import axios from 'axios';
import { cacheData, getCachedData } from './offlineCache';

const API_URL = process.env.REACT_APP_API_URL || '';
const TTL_MS = 30_000;

let cache = null;
let cacheAt = 0;
let inFlight = null;

export function invalidateSettingsCache() {
  cache = null;
  cacheAt = 0;
  inFlight = null;
}

// The last settings fetched, without a request (null if none are cached)
export const peekSettings = () => cache;

export async function getSettings() {
  const now = Date.now();
  if (cache && now - cacheAt < TTL_MS) return cache;
  if (inFlight) return inFlight;

  inFlight = axios.get(`${API_URL}/api/settings`)
    .then(res => {
      cache = res.data;
      cacheAt = Date.now();
      inFlight = null;
      cacheData('settings', res.data);
      return cache;
    })
    .catch(async err => {
      inFlight = null;
      // No signal: the band's name, logo and plan as last seen, so offline pages stay branded
      if (!err.response) {
        const saved = await getCachedData('settings');
        if (saved) return saved.data;
      }
      throw err;
    });

  return inFlight;
}
